module.exports = __webpack_public_path__ + "img/map.a04ea4ed.svg";